import { StateProvider } from '@uirouter/angularjs';
import { AtendimentoListagemController } from './listagem/listagem.component';

export function AtendimentoRouter($stateProvider: StateProvider) {
  'ngInject';

  $stateProvider
  .state('relacionamento', {
    url: '/relacionamento?tour',
    template: require('./listagem/listagem.component.html'),
    controller: AtendimentoListagemController,
    controllerAs: '$ctrl',
    params: { newTicket: false }
  })
  .state('relacionamento-nova-solicitacao', {
    url: '/relacionamento/nova-solicitacao',
    component: 'appAtendimentoNovaSolicitacao',
  })
  .state('relacionamentodetalhes', {
    url: '/relacionamento/{ticketId}',
    component: 'appAtendimentoDetalhes',
  });
}
